export const ENTITY_TYPES_MAP = {
  FIELD: "field",
  BLOCK: "block",
};

export const FORM_EDITOR_VARIANTS = {
  BLOCK: "block",
  CHECK: "check",
  PACKAGE: "package",
  FORM: "form",
};

export const BATCH_PROCESSING_EXCLUDED_FIELDS = [
   "Date",
   "Date Range",
   "Date Range (Timeline)",
   "Referee Email",
   "Referee Name",
   "Referee Phone",
   "Referee Title",
   "Consent",
   "File",
   "Label Info Rich Text",
   "Label (Info Text)",
   "Signature",
   "Webcapture",
]
